/**
 * @ngdoc    directive
 * @name     csm.ui.validators.directive:zipCodeValidator
 * @restrict A
 * @param    {string=} zipCodeValidator Error popup title.
 * @param    {string=} csmRequired      "false"=value is not required.
 * @param    {string=} disableValidator "true"=skip validation.
 *
 * @description
 * Validator to verify a valid zipcode.
 **/
/* @ngInject */ export function zipCodeValidator(CSMValidatorService) {
  var RE_ZIP_CODE = /^\d{5}(-?\d{4})?$/;

  return CSMValidatorService.makeDirective({
    doValidate: function (value) {
      var error = CSMValidatorService.BaseValidator.prototype.doValidate.call(
        this,
        value
      );
      return (
        error || (value && !RE_ZIP_CODE.test(value) ? 'Invalid zip code' : null)
      );
    }
  });
}
